<template lang="pug">
  .products__preloader
    img(src="@/assets/img/global/loader.gif" alt="")
</template>

<script>
export default {
  name: 'ProductsPreloader'
}
</script>
